import React from 'react'

export const FormField = ({
  children,
  label,
  optional = false,
}: React.PropsWithChildren<{ label: string; optional?: boolean }>) => {
  return (
    <div className="flex flex-column gap-10">
      <span className="text-primary font-medium text-16 leading-24 m-0">
        {label}
        {optional ? <span className="text-tertirary"> (optional)</span> : null}
      </span>
      {children}
    </div>
  )
}
